export default __webpack_public_path__ + "static/media/Background_00088.a969a6d0.png";